<template>
<div class="container">

<!-- <div class="row center empty" v-show="!list||list.length==0">
	<i class="fa fa-shopping-cart"></i>
	<p>该订单已过期</p>
</div> -->


<div class="row item" v-for="v in list" :key="v.id">
	<div class="col-3" @click="todetail(v)">
		<img :src="picurl+v.big_pic" :alt="v.name">
	</div>
	<div class="col-7">
		<div class="row" @click="todetail(v)">
			<h4>{{v.name}} </h4>
		</div>
		<div class="row gray pd">
			<span>数量：{{v.gnum}} </span>&nbsp; 
			<span v-if="v.attrs>0">规格：{{v.attr_value}}</span>
		</div>
		<div class="row pd">
			<span class="red">¥<span class="price">{{v.newprice/100}}</span></span>
			<span class="gray oprice" v-show="v.price!=v.newprice">¥{{v.price/100}}</span>
      <small class="gray" v-show="v.price!=v.newprice">价格发生了变动</small>
		</div>
	</div>
</div>

<div class="row tr bwhite total">
	共 {{totalnum}} 件，合计：<span class="red"><span class="price">¥ {{total/100}}</span></span>
</div>

<!-- 优惠券 -->
<div class="yh">
<div class="row bwhite gray">
	<div class="col-2 center">优惠券</div>
	<div class="col-7" @click="showmycard">
    <span class="noyh" v-show="hadcard==false">暂无可用的优惠券</span>
    <span class="noyh" v-show="hadcard&&!now">未使用优惠券</span>
    <div class="row nopadding" v-show="now.can">
      <div class="col-7 nopadding"><span class="myfree">已选1张</span></div>
      <div class="col-3 nopadding alignr">-¥ {{freemoney/100}}</div>
    </div>
  </div>
	<div class="col-1 center"><i class="fa fa-angle-right"></i></div>
</div>
</div>

<mt-popup v-model="showcard" class="popup" position="right">
<div class="row title center" @click="close">
	<i class="fa fa-angle-left"></i>
  我的优惠券
</div>	


<card :card="card" :type="1" :cardid="now?parseInt(now.card_id):0" @select="select_card"></card>


<div class="row center">
    此优惠券可抵 <span class="red">¥ {{freemoney/100}} 元</span>
</div>

<div class="row center pd">
    <mt-button size="large" type="primary" @click="close">确 定</mt-button>
</div>

</mt-popup>
<!-- end 优惠券 -->

<div class="yh" v-show="list.length>0">
    <div class="row gray pay center">
        {{is_weixin?'请长按二维码进行支付':'选择支付方式'}}
    </div>

    <div class="qr-code" v-if="is_weixin">
        <p v-show="!imgurl" class="center">支付二维码生成中...</p>
        <img :src="imgurl" alt="支付二维码" v-if="imgurl" class="pay-qrcode">
    </div>

    <div class="row payi" @click="select('wx')" v-if="!is_weixin">
        <i class="fa fa-check-circle red" v-show="index=='wx'"></i>
        <i class="fa fa-circle-o gray" v-show="index!='wx'"></i>
        <i class="fa fa-weixin"></i>
        微信支付
    </div>

    <div class="row payi" @click="select('zfb')"  v-if="!is_weixin">
    <i class="fa fa-check-circle red" v-show="index=='zfb'"></i>
    <i class="fa fa-circle-o gray" v-show="index!='zfb'"></i>
    <img src="../../images/zfb.png" alt="支付宝" class="zfb">
    支付宝
    </div>

</div>


<form :action="payhost+payurl" method="POST" class="row mypay bwhite"  v-if="!is_weixin">
    <input type="hidden" name="token" :value="token">
    <input type="hidden" name="orderid" :value="ocode"/>
    <input type="hidden" name="money" :value="total-freemoney"/>
    <input type="hidden" name="body" :value="instr"/>
    <input type="hidden" name="card_num" :value="now.card_num">
     总计：<span class="red"><span class="price">¥ {{(total-freemoney)/100}}</span></span>&nbsp;
     <mt-button class="btn-red">立即支付</mt-button>
</form>



</div>
</template>
<script>
import card from "../../lib/card.vue";

export default {
  data:function(){
  	return {
      list:"",
      picurl:picurl,
      total:0,
      totalnum:0,
      index:"zfb",
      instr:"",
      ocode:"",
      imgurl:"",//支付二维码
      payhost:window.payhost,
      payurl:"/Paym/pay",
      timer:"",
      hadcard:false,
      now:"",
      card:[],
      showcard:false,
      token:"",
      is_weixin:fun.is_weixin(),
  	}
  },
  created:function(){
    this.$emit("setTitle","确认订单");
    this.token=fun.local("token");
    this.init();
  },
  components:{card},
  computed:{
   freemoney:function(){
     if(!this.now){return false;}
     if(this.now.type==1){
       return this.now.price;
     }else if(this.now.type==2){
       return parseInt(this.total*(100-this.now.discount)/100);
     }
   }
  },
  methods:{
  	init:function(){
  		var _this=this;
        var data={
            "order_code":this.$route.params.id,
        }
        _this.dopay();
  		fun.post(mydata.apiuser+"buy",data,function(d){
  			//console.log(d);
  			if(d.status==1){
  				_this.list=d.info.orders;
  				_this.total=d.info.total;
                _this.ocode=d.info.orders[0]['order_code'];
                _this.count(d.info.orders);
                _this.setinstr(d.info.orders);
                _this.get_my_card(data);
  			}else{
  				_this.$toast(d.info);
  			}
  		})   
    },
    get_my_card:function(data){
      var _this=this;
      fun.post(mydata.api+"Member/get_my_card_byorder",data,function(d){
          console.log(d)
          if(d.status==1){
                _this.card=d.info;
                _this.card.sort(function(a,b){
                    return b.can-a.can;
                })
                if(_this.card[0]['can']){
                    _this.hadcard=true;
                    _this.now=_this.card[0];
                }
          } 
          if(_this.is_weixin){
              _this.get_qrcode();
          }
      },true)
    },
    get_qrcode(){
        var data={
            order_code:this.ocode,
            total:this.total,
            cardnum:this.now?this.now.card_num:"",
        };
        var _this=this;
        fun.post(this.payhost+"/Paywxweb/qrpay",data,function(d){
            console.log(d)
            if(d.status==1){
                _this.imgurl=d.info;
                _this.ispay();
            }else{
                _this.$messagebox.alert(d.info);
            }
        })
    },
    showmycard:function(){
        if(!this.card||this.card.length<1){this.$toast("暂无优惠券");return;}
        this.showcard=true;
    },
    close:function(){
        this.showcard=false;
    },
    select_card:function(d){
        if(!d||d.can==false){return;}
        if(d.card_id==this.now.card_id){this.now="";return;}
        this.now=d;
    },
    //跳转后可能需要定时查询
    dopay:function(){
        //if(this.index!="wx"){return;}
        this.ispay();
        var _this=this;
        this.timer=setInterval(function(){
            _this.ispay();
        },3000)
    },
    ispay:function(){
      var _this=this;
      var data={
        "order_code":this.$route.params.id,
      }
      fun.post(this.payhost+"/Paywx/ispay",data,function(d){
       // console.log(d);
        if(d.status==1){
        clearInterval(_this.timer);
        _this.$messagebox.alert("支付成功").then(function(d){
            _this.$router.push("/user/order/3");
        })
        }
      },true)
    },
    select:function(index){
        this.index=index;
        this.payurl=index=="zfb"?"/Paym/pay":"/Paywx/pay";
    },
    count:function(orders){
        var len=orders.length;
        var totalnum=0;
        for(var i=0;i<len;i++){
                totalnum+=parseInt(orders[i]['gnum']);     
        }
        this.totalnum=totalnum;
    },
    setinstr:function(orders){
        this.instr=orders[0]['name'];
        if(orders[0]['attrs']>1){
            this.instr+="("+orders[0]['attr_value']+")";
        }
        if(orders.length>1){
            this.instr+="等商品";
        }
    },
  	todetail:function(v){
        this.$router.push("/mall/detail/ucode/"+v.gucode);
  	},
  }
}	

</script>

<style scoped>
.form{height:2rem;display:inline-block;width:30%;}
.zfb{width:1.2rem;position:relative;top:.2rem;margin-right: .5rem;}
.container{background: rgb(251,251,251);padding-bottom: 3rem;}
.pd{padding:0 .3rem;}
.item{padding:.3rem 3%;border-bottom: 1px solid #eee;background: white;}
.item img{width:90%;margin:5%;}
.item h4{height:3.6rem;font-weight:500; }
.price{font-size: 1.3rem;}	
.oprice{text-decoration:line-through;}
.check{height:7.3rem;line-height: 7.3rem;text-align:center;font-size:1.3rem;}
.tr{text-align:right;padding:.5rem 1rem;}
.alignr{text-align:right;}
.total{padding:.8rem;}
.yh{float:left;margin:.8rem 0;background: white;width:100%;height:3rem;line-height:3rem;}
/* .yh .row{padding:.5rem;} */
.noyh{background:#ddd;color:white;padding:.2rem;}
input{width:100%;height:1.5rem;border:0;}
.pay{font-size:1.2rem;padding:0 .5rem;border-bottom:1px solid #eee;line-height:3rem;}
.fa-weixin{color:rgb(64,164,12);}
.yh .payi{padding:0 .7rem;}
.payi{border-bottom: 1px solid #eee;}
.payi i{font-size:1.2rem;margin-right: .5rem;}
.payi .fa-check-circle{font-size: 1.2rem;}
.mypay{width:100%;height:3.5rem;line-height: 3.5rem;text-align:right;position: fixed;bottom:0;
	border-top:1px solid #eee;}
.btn-red{background: red;color:white;border-radius: 0;height:3.5rem;line-height: 3.5rem;}
.myfree{border:1px solid red;color:red;padding:.1rem .3rem;}
.edit{padding:0 .5rem;text-align: right;background: white;border-bottom: 1px solid #eee;}
.btn{border:0;background: white;color: #aaa;font-size:1.1rem;box-shadow:0 0 0 white;}

.popup{width:100%;height:100%;overflow: auto;background:rgb(251,251,251);}
.title{padding:.5rem;font-size: 1.2rem;color:rgb(0,144,255);border-bottom: .2rem solid #eee;}
.center i{font-size: 1.5rem;color:#adadad;}
.title i{float: left;margin-left:.5rem;color:rgb(0,144,255);}
.pd{padding:1rem;}
.pay-qrcode{
    width:100%;
}
</style>


// WEBPACK FOOTER //
// src/components/user/buy.vue